import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';

const FEATURES = [
  { icon: '🎤', title: 'Speakers', text: 'One directory for everyone — from a first-contact lead through active speaker.' },
  { icon: '📅', title: 'Events', text: 'Chapter meetings with logistics, PDU info, and a calendar view.' },
  { icon: '📋', title: 'Engagements', text: 'Agreement status, checklist, and reminders for each speaker at each event.' },
];

export function LoginPage() {
  const { login, user, isRecovery } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user && !isRecovery) {
      navigate('/', { replace: true });
    }
  }, [user, isRecovery]); // eslint-disable-line

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--gradient-page)',
        padding: 'var(--space-8)',
      }}
    >
      {/* Two-column layout — marketing copy alongside the sign-in card,
          matching the reference site's login page structure. */}
      <div className="login-grid">
        {/* Left: what the product does */}
        <section>
          <p style={{ fontSize: 12, fontWeight: 800, letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-primary)', marginBottom: 'var(--space-3)' }}>
            Holistic Agility and Logistics
          </p>
          <h1 style={{ fontSize: 'var(--text-3xl)', letterSpacing: '-0.5px', marginBottom: 'var(--space-3)' }}>
            Every speaker relationship, tracked in one place.
          </h1>
          <p style={{ fontSize: 'var(--text-base)', color: 'var(--color-text-muted)', marginBottom: 'var(--space-6)', maxWidth: '46ch' }}>
            For PMI chapters, Agile &amp; Lean guilds, and software, product, and related communities —
            from first contact through the stage.
          </p>
          <div className="stack-2">
            {FEATURES.map((f) => (
              <div key={f.title} style={{ display: 'flex', gap: 'var(--space-3)', alignItems: 'flex-start' }}>
                <span style={{ fontSize: 'var(--text-xl)' }} aria-hidden="true">{f.icon}</span>
                <div>
                  <h2 style={{ fontSize: 'var(--text-sm)', marginBottom: 2 }}>{f.title}</h2>
                  <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)' }}>{f.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              marginTop: 'var(--space-6)',
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-lg)',
              boxShadow: 'var(--shadow-sm)',
              padding: 'var(--space-5)',
            }}
          >
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)', marginBottom: 'var(--space-3)' }}>
              Access is by invitation. Want to use this for your chapter or organization?
            </p>
            <a
              href="mailto:john@logisticalagility.com?subject=Speaker%20Engagement%20Tracker%20access"
              className="btn btn-primary"
              style={{ display: 'inline-block', textDecoration: 'none' }}
            >
              Contact me for access
            </a>
          </div>
        </section>

        {/* Right: sign-in card */}
        <main
          style={{
            borderRadius: 'var(--radius-2xl)',
            border: '1px solid var(--color-border)',
            boxShadow: 'var(--shadow-lg)',
            background: 'var(--color-surface)',
            overflow: 'hidden',
          }}
        >
          {/* Brand banner — text block left, logo right, matching the
              reference site's header layout exactly (flex row, not a
              centered stack). */}
          <div style={{ background: 'var(--color-brand-gradient)', padding: 'var(--space-8)', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 'var(--space-5)' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: 12, fontWeight: 800, letterSpacing: '2px', textTransform: 'uppercase', color: '#9be7ff', marginBottom: 'var(--space-2)' }}>
                Holistic Agility and Logistics
              </p>
              <h2 style={{ fontSize: 'var(--text-2xl)', color: '#fff', marginBottom: 'var(--space-2)' }}>
                Speaker Engagement Tracker
              </h2>
              <p style={{ fontSize: 'var(--text-sm)', color: '#cfe6f5' }}>
                Authorized users only
              </p>
            </div>
            <img src="/logo.png" alt="Holistic Agility and Logistics, LLC" style={{ width: 56, height: 'auto', borderRadius: 'var(--radius)', flexShrink: 0 }} />
          </div>

          {/* Body */}
          <div style={{ padding: 'var(--space-8)', display: 'flex', flexDirection: 'column', gap: 'var(--space-5)' }}>
            <div>
              <h3 style={{ fontSize: 'var(--text-lg)', marginBottom: 'var(--space-1)' }}>Sign in</h3>
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
                Use the email address and password associated with your invitation.
              </p>
            </div>

            <button className="btn btn-primary btn-lg" onClick={login} style={{ width: '100%' }}>
              Sign in
            </button>

            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-subtle)' }}>
                Access is invite-only. Contact john@logisticalagility.com if access is desired.
              </p>
              <p style={{ fontSize: 10, color: 'var(--color-text-subtle)', opacity: 0.6, marginTop: 'var(--space-2)' }}>
                © 2026 Holistic Agility and Logistics, LLC
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
